import { Injectable } from '@angular/core';
import { AbstractControlOptions, AsyncValidatorFn, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';

@Injectable()
export class SolvimonEventForm {

  constructor(private formBuilder: FormBuilder) {
  }

  public buildForm(): FormGroup {
    return this.formBuilder.group({
      name: ['', Validators.required],
      definition: ['', Validators.required],
      isActive: [true, Validators.required],
      event: ['', Validators.required],
      metricId: ['', Validators.required],
      metricRef: ['', Validators.required],
      properties: this.formBuilder.group({}),
      values: this.formBuilder.group({}),
    });
  }

}
